export default "__VITE_ASSET__8f89b50a__"